import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { OperativeZoneConfiguration, ProductData } from 'src/app/models/pool-parameters/pool-parameters.model';
import { EditOption } from '../edit-product-parameters-modal/edit-product-parameters-modal.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PoolManagerService } from 'src/app/services/pool-manager/pool-manager.service';
import { Zone } from 'src/app/models/zone/zone.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-edit-operative-zone-modal',
  templateUrl: './edit-operative-zone-modal.component.html',
  styleUrls: ['./edit-operative-zone-modal.component.css']
})
export class EditOperativeZoneModalComponent {


  operativeZone!: OperativeZoneConfiguration;
  private originalOperativeZone!: OperativeZoneConfiguration;
  OperativeZoneForm!: FormGroup;

  IsStartingFrom: boolean = false;

  onClose: Subject<any> = new Subject();

  SaveLoading: boolean = false;

  constructor(private BsModalRef: BsModalRef, private poolSvc: PoolManagerService
  ) {

  }

  ngOnInit() {
    if (this.operativeZone) {
      this.setProductDataForm(this.operativeZone)
    }

    this.OperativeZoneForm.valueChanges.subscribe((data) => {
    })
  }

  closeModal(operativeZone?: OperativeZoneConfiguration) {
    this.onClose.next(operativeZone);
    this.onClose.complete();
    this.BsModalRef.hide();
  }
  setProductDataForm(operativeZone: OperativeZoneConfiguration): void {
    this.OperativeZoneForm = new FormGroup({
      operativeZoneConfigurationGuid: new FormControl(operativeZone.operativeZoneConfigurationGuid, Validators.required),
      description: new FormControl(operativeZone.description, Validators.required),
      timeLimit: new FormControl(operativeZone.timeLimit, Validators.required),
    })
    this.originalOperativeZone = { ...this.OperativeZoneForm.value };
  }

  saveParameters(): void {
    this.SaveLoading = true;
    let OperativeZoneModify = this.buildProductDataObj();
    this.closeModal(OperativeZoneModify);
  }

  buildProductDataObj(): OperativeZoneConfiguration {
    return {
      operativeZoneConfigurationGuid: this.OperativeZoneForm.get('operativeZoneConfigurationGuid')?.value,
      description: this.OperativeZoneForm.get('description')?.value,
      timeLimit: this.OperativeZoneForm.get('timeLimit')?.value,
    }
  }

  get isFormModified(): boolean {
    return this.shallowCompare(this.OperativeZoneForm.value, this.originalOperativeZone);
  }

  shallowCompare(a: any, b: any): boolean {
    return Object.keys(a).some(key => a[key] !== b[key]);
  }
}


